<template>
	<layout-admin>
		<!--<h1>hallo user grid!</h1>-->

		<admin-crop-grid
			:title="title"
			:rows="data"
			:cols="cols"
			v-bind:row-href="rowHref"
			:defaultOrderByAscending="false"
		/>
	</layout-admin>
</template>

<script>
export default {
	props: {
		data: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			title: this.__("Auction Bids"),
			cols: [
				{
					id: "id",
					name: "ID",
					render: (id) => "#" + id,
				},
				{
					id: "product__grade",
					name: this.__("Article"),
					filterOptions: Object.values(this.$cropOptions.productGradeOptions)
						.flat()
						.map((o) => {
							return {
								id: this.__(o.name),
								name: this.__(o.name),
							};
						}),
					render: (x, row) =>
						window.__(
							this.$cropOptions.getLabel(
								row.product__grade,
								this.$cropOptions.productGradeOptions
							)
						),
				},
				{
					id: "product__harvest",
					name: this.__("Harvest"),
					render: (x, row) => row.product__harvest,
				},
				{
					id: "qty__mt",
					name: this.__("Quantity"),
					render: (x, row) => row.qty__mt,
				},
				{
					id: "price__mt",
					name: this.__("Price"),
					render: (x, row) => row.price__mt,
				},
				{
					id: "location_mode",
					name: this.__("Location"),
					render: (x, row) =>
						window.__(
							this.$cropOptions.getLabel(
								row.location__mode,
								this.$cropOptions.locationModeOptions
							)
						),
				},
				{
					id: "location",
					name: this.__("City"),
					render: (x, row) => window.__(row.location__desc),
				},
				{
					id: "date_mode",
					name: this.__("Fulfilment Date"),
					render: (x, row) =>
						window.__(
							this.$cropOptions.getLabel(
								row.date__type,
								this.$cropOptions.dateModeOptions
							)
						),
				},
				{
					id: "date_range",
					name: this.__("Period "),
					render: (x, row) => row.date__desc,
				},
				{
					id: "seller_company_name",
					name: this.__("Seller"),
					render: (x, row) =>
						row.seller.company_name + (row.started_by == "SELLER" ? "*" : ""),
				},
				{
					id: "buyer_company_name",
					name: this.__("Buyer"),
					render: (x, row) =>
						row.buyer.company_name + (row.started_by == "BUYER" ? "*" : ""),
				},
				{
					id: "updated_at",
					name: this.__("Updated"),
					render: (x, row) => this.$cropOptions.formatIsoStamp(row.updated_at),
				},
			],
		};
	},
	methods: {
		rowHref(row) {
			return window.baseUrl + "/admin/auction_bids/" + row.id.replace("#", "");
		},
	},
};
</script>
